import React, { useEffect } from 'react';
import { useFullReset } from '../../context/Kiosk/kiosk';

export const ResetKiosk: React.FC = () => {
    const reset = useFullReset();

    useEffect(() => {
        reset();
    }, [reset]);

    return <div />;
};